import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ShineIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={Number(size) * (23 / 22)}
      viewBox='0 0 22 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M9.53223 1.44531C10.1079 0.222448 11.7593 0.187788 12.4043 1.33008L12.4629 1.44434L12.4639 1.44531L14.6807 6.13867V6.13965C14.775 6.34097 14.9562 6.47195 15.1533 6.50195L20.1064 7.25488H20.1055C21.4666 7.45961 21.9483 9.16153 21.0146 10.1133L17.4316 13.7656C17.2991 13.9008 17.2258 14.0925 17.2354 14.293L17.2451 14.3789L18.0918 19.5361V19.5371C18.3066 20.8606 16.9581 21.9815 15.7168 21.2988L11.2881 18.8643C11.1072 18.7649 10.8957 18.7662 10.7207 18.8633H10.7197L6.28906 21.2988C5.04778 21.9814 3.70022 20.8606 3.91504 19.5371V19.5361L4.76172 14.3789L4.77051 14.293C4.77927 14.0951 4.70718 13.9021 4.5752 13.7646L0.985352 10.1143V10.1133C0.0499716 9.15979 0.535734 7.46407 1.89258 7.25488H1.89355L6.84668 6.50195L6.91992 6.48633C7.08782 6.43833 7.23679 6.31575 7.31934 6.13965V6.13867L9.53223 1.44531Z'
        stroke={color}
      />
      <path
        d='M8.06476 10.7209C8.41604 10.7209 8.7008 10.4213 8.7008 10.0519C8.7008 9.6824 8.41604 9.38289 8.06476 9.38289C7.71348 9.38289 7.42871 9.6824 7.42871 10.0519C7.42871 10.4213 7.71348 10.7209 8.06476 10.7209Z'
        fill={color}
      />
      <path
        d='M14.2299 10.7208C14.5812 10.7208 14.866 10.4213 14.866 10.0518C14.866 9.68233 14.5812 9.38281 14.2299 9.38281C13.8787 9.38281 13.5939 9.68233 13.5939 10.0518C13.5939 10.4213 13.8787 10.7208 14.2299 10.7208Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.2199 11.752C13.0575 12.9157 12.1929 13.8007 11.1461 13.8007C10.1026 13.8007 9.23463 12.9122 9.07231 11.752C9.0425 11.5429 9.18826 11.3547 9.38702 11.3547H12.9052C13.1039 11.3547 13.2497 11.5464 13.2199 11.752ZM12.0143 13.0795C12.0143 12.5221 11.6267 12.0691 11.1463 12.0691C10.666 12.0691 10.2784 12.5221 10.2784 13.0795H12.0143Z'
        fill={color}
      />
    </svg>
  )
})

ShineIcon.displayName = 'ShineIcon'
